import { useMemo, useState } from "react";

import type { IVehicleCard } from "../components/VehicleCard";
import type { IVehicleFilter } from "../components/VehicleFilter";

const useFilterCards = (cards: IVehicleCard[], filters: IVehicleFilter[]) => {
  const [selectedFilter, setSelectedFilter] = useState<string>("all-vehicles");

  const handleFilterChange = (filterId: string) => {
    setSelectedFilter(filterId);
  };

  const filteredCards = useMemo(() => {
    if (!selectedFilter || selectedFilter === "all-vehicles") {
      return cards;
    }
    const selectedFilterTags =
      filters?.find((filter) => filter?.id === selectedFilter)?.tags || [];
    return cards.filter((card) =>
      card.tags.some((tag) => selectedFilterTags.includes(tag)),
    );
  }, [selectedFilter, cards, filters]);

  return { filteredCards, handleFilterChange, selectedFilter };
};

export default useFilterCards;
